var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 80,
    viewBox: "0 0 33 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0514 80.0056H20.1984C18.8991 79.5138 17.9025 78.8803 17.2897 77.5611C17.1938 77.3525 16.8099 76.3016 16.8099 76.1749V49.3003C16.5146 48.9351 15.8502 48.95 15.577 49.3003V76.0184C15.577 76.6519 14.92 77.8667 14.4992 78.366C12.1589 81.1757 7.59656 79.9088 6.97643 76.2942L6.85831 29.8561C6.26772 29.0884 5.59591 29.5505 5.54424 30.4001L5.47779 50.0158C4.39995 52.8404 1.04831 52.505 0 49.8518V25.0118C0.634892 21.6506 3.12279 19.1837 6.54825 18.9154C12.8307 18.4161 19.7629 19.2806 26.1192 18.9378C29.5742 19.3626 32.099 22.0456 32.3869 25.5558C31.9587 33.1949 32.9406 41.4376 32.3869 49.0022C32.1359 52.423 28.1863 53.1534 26.8943 50.0232L26.8279 30.4001C26.7762 29.3791 25.8165 29.0735 25.44 30.0946V76.1824C25.1595 78.1201 23.8085 79.402 22.0441 80.0056H22.0514Z",
    fill: "#F1805E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1896 15.8296C20.5033 15.8296 24.0002 12.2861 24.0002 7.91482C24.0002 3.54359 20.5033 0 16.1896 0C11.8759 0 8.37891 3.54359 8.37891 7.91482C8.37891 12.2861 11.8759 15.8296 16.1896 15.8296Z",
    fill: "#F1805E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManOrange);
export default __webpack_public_path__ + "static/media/man-orange.8e4d0e24f9fd3da13ed7b6510e46aed0.svg";
export { ForwardRef as ReactComponent };